type DealerCardProps = {
  name: string;
  location: string;
  website: string;
  partenaire: boolean;
  description?: string;
  reviews?: number;
};

export default function DealerCard({
  name,
  location,
  website,
  partenaire,
  description,
  reviews,
}: DealerCardProps) {
  const rel = "noreferrer noopener" + (partenaire ? "" : " nofollow");
  return (
    <>
      <div className="card">
        <h2 style={{ fontWeight: 700 }}>
          {name}
          {partenaire && (
            <span
              style={{
                marginLeft: 8,
                color: "#f5a623",
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              ⭐ Partenaire Premium
            </span>
          )}
        </h2>
        <p>{description}</p>
        <div className="small">{location}</div>
        {website && (
          <p
            className="small"
            style={{ marginTop: 8, color: "#99C3FF", fontWeight: 500 }}
          >
            <a href={website} rel={rel} target="_blank">
              Site web de {name}
            </a>
          </p>
        )}
        {reviews && <div className="trust">⭐ {reviews}/ 5 (avis clients)</div>}
      </div>
    </>
  );
}
